import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";

import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";

import { message } from "antd";
import { purchasePoService } from "./purchasePoService"
import { IPurchasePoFields, IPurchasePoList, IPurchasePoDetail, IPurchasePoSearch, IPurchasePoStatistics } from "./purchasePoType"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";

export interface IMdBeSearchField {
    code?: string;
    name?: string;
    corporation?: string;
    phone?: string;
    address?: string;
    bank?: string;
    bankAccount?: string;
}

export const usePurchasePoModel = createModel(function () {
    const initSearchParam: IPurchasePoSearch = {};
    const initDataSource: IPurchasePoDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: IPurchasePoStatistics = {
        totalNum: 0,
        totalAmount: 0,
        receivedAmount: 0,
        amountReceived: 0,
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IPurchasePoSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IPurchasePoDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IPurchasePoFields>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);
    const [descTotal, setDescTotal] = useState<IPurchasePoStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IPurchasePoStatistics>(initDesc);
    const [descRows, setDescRows] = useState<IPurchasePoFields[]>([]);
    
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        console.log(selectedData)
        setSelectedRow(selectedData as IPurchasePoDetail)
    }, [selectedRowKeys])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount, amountReceived } = item
            newRowsDescTotal.totalNum += +formatNum(totalNum)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            newRowsDescTotal.receivedAmount += +formatNum(totalAmount)
            newRowsDescTotal.amountReceived += +formatNum(amountReceived)

        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdBeSearchField) => {
        // console.log(updateParam)
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }

    const loadData = async (page?: ISearchPage, searchValue: IPurchasePoSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await purchasePoService.page(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    const syncData = async () => {
        // let ret = await purchasePoService.sync(searchParam);
        // ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        // ret && await loadData()
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await purchasePoService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    //列表导出
    const listExport = async () => {
        let result = await purchasePoService.export({...searchParam,id: selectedRowKeys.join(),});
        convertRes2Blob(result)
    }
    const detailsExport = async () => {
        let result = await purchasePoService.detailsExport({
            ...searchParam,
            id: selectedRowKeys.join(),
            "pageSize": "0",
            "pageNum": "0",
        });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedRow,
        /***method***/
        setSelectedRow,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        syncData,
        getSelectedRowData,
        invalidateData,
        listExport,
        detailsExport,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows
        
    }
});